// Central content + curated imagery for the Spherio Living site

export const IMAGES = {
  heroLiving:
    "https://images.unsplash.com/photo-1705326701287-346fc37a2c86?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  kitchen1:
    "https://images.unsplash.com/photo-1682662044733-9120471befc7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  kitchen2:
    "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=85",
  kitchen3:
    "https://images.unsplash.com/photo-1556911220-e15b29be8c8f?w=1600&q=85",
  wardrobe1:
    "https://images.pexels.com/photos/30465909/pexels-photo-30465909.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
  wardrobe2:
    "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=1600&q=85",
  interior1:
    "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1600&q=85",
  interior2:
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=1600&q=85",
  interior3:
    "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=1600&q=85",
  bedroom:
    "https://images.unsplash.com/photo-1616137466211-f939a420be84?w=1600&q=85",
  renovation:
    "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=1600&q=85",
  exterior:
    "https://images.unsplash.com/photo-1748063578185-3d68121b11ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  bath:
    "https://images.unsplash.com/photo-1615529182904-14819c35db37?w=1600&q=85",
  misc:
    "https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=1600&q=85",
  // Actual Spherio Living project photography
  projFacadeDay:
    "https://customer-assets-v7afamib.emergentagent.net/job_spherio-home/artifacts/s9y7c8kd_WhatsApp%20Image%202026-09-13%20at%206.15.45%20PM%20%281%29.jpeg",
  projStructure:
    "https://customer-assets-v7afamib.emergentagent.net/job_spherio-home/artifacts/ma1xeegl_WhatsApp%20Image%202026-09-13%20at%206.15.45%20PM%20%283%29.jpeg",
  projJaliLiving:
    "https://customer-assets-v7afamib.emergentagent.net/job_spherio-home/artifacts/f2w4hp3w_WhatsApp%20Image%202026-09-13%20at%206.15.45%20PM%20%284%29.jpeg",
  projPanoramicLiving:
    "https://customer-assets-v7afamib.emergentagent.net/job_spherio-home/artifacts/h3j5uru1_WhatsApp%20Image%202026-09-13%20at%206.15.45%20PM%20%286%29.jpeg",
  projCornerHouse:
    "https://customer-assets-v7afamib.emergentagent.net/job_spherio-home/artifacts/lu0balll_WhatsApp%20Image%202026-09-13%20at%206.15.45%20PM.jpeg",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Kitchens", to: "/modular-kitchens" },
  { label: "Interiors", to: "/home-interiors" },
  { label: "Wardrobes", to: "/wardrobes" },
  { label: "Renovation", to: "/renovation" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    slug: "modular-kitchens",
    index: "01",
    title: "Modular Kitchens",
    tagline: "Kitchens engineered for real life",
    short:
      "Precision-built modular kitchens with premium finishes, smart storage and hardware that lasts a lifetime.",
    image: IMAGES.kitchen1,
    features: [
      "Ergonomic work-triangle layouts",
      "Soft-close German hardware",
      "Moisture-resistant marine-ply cores",
      "Tall units, pull-outs & corner solutions",
    ],
    gallery: [IMAGES.kitchen1, IMAGES.kitchen2, IMAGES.kitchen3],
  },
  {
    slug: "home-interiors",
    index: "02",
    title: "Home Interiors",
    tagline: "End-to-end interiors, one accountable team",
    short:
      "Full-home interiors that balance beauty and function — living, dining, bedrooms and everything between.",
    image: IMAGES.interior1,
    features: [
      "Space planning & 3D visualisation",
      "Curated materials & lighting design",
      "False ceilings & feature walls",
      "Single point of ownership",
    ],
    gallery: [IMAGES.interior1, IMAGES.interior2, IMAGES.interior3],
  },
  {
    slug: "wardrobes",
    index: "03",
    title: "Wardrobes",
    tagline: "Storage that disappears into design",
    short:
      "Sliding, hinged and walk-in wardrobes tailored to your space with intelligent internal organisation.",
    image: IMAGES.wardrobe1,
    features: [
      "Sliding & walk-in configurations",
      "Integrated lighting & mirrors",
      "Custom internal organisers",
      "Scratch & fade resistant laminates",
    ],
    gallery: [IMAGES.wardrobe1, IMAGES.wardrobe2, IMAGES.bedroom],
  },
  {
    slug: "renovation",
    index: "04",
    title: "Renovation",
    tagline: "Transform without the chaos",
    short:
      "Full renovation and remodelling with structured timelines, transparent costs and zero surprises.",
    image: IMAGES.renovation,
    features: [
      "Civil, plumbing & electrical",
      "Waterproofing & flooring",
      "Structured project timelines",
      "Transparent, itemised pricing",
    ],
    gallery: [IMAGES.renovation, IMAGES.bath, IMAGES.misc],
  },
];

export const EXTRA_SERVICES = [
  {
    title: "Architectural Design",
    desc: "Concept to construction drawings led by in-house architects.",
  },
  {
    title: "Smart Home Solutions",
    desc: "Automated lighting, climate, security and voice-controlled living.",
  },
  {
    title: "Modular Storage",
    desc: "Crockery units, TV consoles, study & pooja units built to spec.",
  },
];

export const WHY_CHOOSE = [
  {
    no: "01",
    title: "Technology-led design",
    body: "Photoreal 3D visualisation lets you walk your home before a single panel is cut.",
  },
  {
    no: "02",
    title: "Own factory, own quality",
    body: "Precision manufacturing on calibrated CNC lines — consistent finishes, every time.",
  },
  {
    no: "03",
    title: "Flat, transparent pricing",
    body: "Itemised quotes with no hidden costs. What you approve is what you pay.",
  },
  {
    no: "04",
    title: "On-time, every time",
    body: "Structured 45-day delivery with a dedicated project manager on speed dial.",
  },
];

export const PROCESS = [
  { no: "01", title: "Consultation", body: "We understand how you live, your taste and your budget." },
  { no: "02", title: "Design", body: "Photoreal 3D designs refined until every detail feels right." },
  { no: "03", title: "Manufacturing", body: "Your design goes into precision production at our factory." },
  { no: "04", title: "Installation", body: "Certified installers assemble on site with surgical care." },
  { no: "05", title: "Handover", body: "A final walkthrough, quality sign-off and a 10-year warranty." },
];

export const STATS = [
  { value: "150+", label: "Homes delivered" },
  { value: "45", label: "Day avg. delivery" },
  { value: "10 yr", label: "Warranty" },
  { value: "4.9/5", label: "Customer rating" },
];

export const TESTIMONIALS = [
  {
    name: "Arvind Sharma",
    role: "Homeowner, Ludhiana",
    quote:
      "Spherio Living turned our 3BHK into something out of a magazine. The 3D design was exactly what got built — no surprises.",
    image:
      "https://customer-assets-v7afamib.emergentagent.net/job_spherio-home/artifacts/8ohld5zm_WhatsApp%20Image%202026-09-13%20at%206.42.15%20PM.jpeg",
  },
  {
    name: "Priyank Aggarwal",
    role: "Homeowner, Ludhiana",
    quote:
      "The kitchen is a dream to cook in. Every corner has been thought through. Delivered on the day they promised.",
    image:
      "https://images.pexels.com/photos/16361823/pexels-photo-16361823.jpeg?auto=compress&cs=tinysrgb&w=400",
  },
  {
    name: "Shelly Kapoor",
    role: "Homeowner, Ludhiana",
    quote:
      "Loved the transparency. The itemised quote never changed. Our walk-in wardrobe is the highlight of the house.",
    image:
      "https://images.pexels.com/photos/36153394/pexels-photo-36153394.jpeg?auto=compress&cs=tinysrgb&w=400",
  },
];

export const FAQS = [
  {
    q: "How long does a full home interior take?",
    a: "Most full-home projects are delivered within 45–60 days from design sign-off, depending on scope. We share a locked timeline before work begins.",
  },
  {
    q: "Is the consultation really free?",
    a: "Yes. Your first design consultation, space assessment and 3D concept discussion are completely free with no obligation.",
  },
  {
    q: "Do you offer a warranty?",
    a: "Every Spherio Living project carries up to a 10-year warranty on modular cabinetry and a 1-year service warranty on installation.",
  },
  {
    q: "Can I see the design before manufacturing?",
    a: "Absolutely. We build photoreal 3D visualisations so you can walk through your home and approve every detail before production.",
  },
  {
    q: "How is pricing calculated?",
    a: "Pricing is flat and itemised — you see the cost of every unit, material and finish upfront. No hidden charges, ever.",
  },
];

export const PORTFOLIO = [
  { title: "Modern Facade, Ludhiana", tag: "Architecture", image: IMAGES.projFacadeDay, size: "tall", cropStyle: { transform: "scale(1.28)", transformOrigin: "center 20%" } },
  { title: "Matte Noir Kitchen", tag: "Modular Kitchen", image: IMAGES.kitchen1, size: "wide" },
  { title: "Structure to Home", tag: "Renovation", image: IMAGES.projStructure, size: "std" },
  { title: "Warm Minimal Living", tag: "Interior", image: IMAGES.interior2, size: "std" },
  { title: "Island Kitchen", tag: "Modular Kitchen", image: IMAGES.kitchen2, size: "tall" },
  { title: "Screened Living Room", tag: "Interior", image: IMAGES.projJaliLiving, size: "wide" },
  { title: "Panoramic Living Suite", tag: "Interior", image: IMAGES.projPanoramicLiving, size: "std" },
  { title: "The Corner House", tag: "Architecture", image: IMAGES.projCornerHouse, size: "std" },
];

export const TEAM = [
  {
    name: "Er. Yogesh Sharma",
    role: "Lead Structural Engineer",
    icon: "award",
    bio: "NIT Kurukshetra. Expertise in load-bearing design and material science for residential projects.",
  },
  {
    name: "Er. Sunil Aggarhari",
    role: "Senior Civil Engineer",
    icon: "layers",
    bio: "Specialising in site assessment, foundation integrity and sustainable construction practices.",
  },
  {
    name: "Er. Saurav Singh",
    role: "Lead Digital Transformation",
    icon: "code",
    bio: "Driving our AI-powered project tracking, 3D visualisation and client dashboard innovations.",
  },
];

export const KITCHEN_TYPES = [
  {
    slug: "straight",
    title: "Straight Kitchen",
    image: "https://images.pexels.com/photos/2724749/pexels-photo-2724749.jpeg?auto=compress&cs=tinysrgb&w=1400",
    desc: "A single-wall layout that keeps everything within arm's reach — clean, efficient and perfect for compact 1BHKs and studios.",
    bestFor: "Studios, 1BHKs, narrow rooms",
    bullets: ["Small footprint", "Sleek visual line", "Budget-friendly"],
  },
  {
    slug: "l-shaped",
    title: "L-Shaped Kitchen",
    image: "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?w=1400&q=80",
    desc: "Two adjacent walls form a perfect L — the most popular layout in India. Frees up floor space and creates an intuitive work-triangle.",
    bestFor: "Most 2 & 3 BHK homes",
    bullets: ["Optimal work-triangle", "Corner pull-out storage", "Great with an open plan"],
  },
  {
    slug: "u-shaped",
    title: "U-Shaped Kitchen",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=1400&q=80",
    desc: "Three walls of cabinetry deliver maximum storage and prep counter — designed for the serious home cook.",
    bestFor: "Serious cooks, larger families",
    bullets: ["Maximum storage", "Multiple work zones", "Immersive cooking feel"],
  },
  {
    slug: "parallel",
    title: "Parallel / Galley",
    image: "https://images.unsplash.com/photo-1556911220-e15b29be8c8f?w=1400&q=80",
    desc: "Two parallel counters running along facing walls — extremely efficient and made for multi-cook households.",
    bestFor: "Long, narrow kitchens",
    bullets: ["Two-cook workflow", "Symmetrical storage", "Very ergonomic"],
  },
  {
    slug: "island",
    title: "Island Kitchen",
    image: "https://images.unsplash.com/photo-1682662044733-9120471befc7?w=1400&q=80",
    desc: "A free-standing counter anchors an open-plan kitchen — extra prep space, casual seating and a statement centrepiece.",
    bestFor: "Open-plan luxury homes",
    bullets: ["Bar-height seating", "Extra prep + storage", "Statement centrepiece"],
  },
  {
    slug: "peninsula",
    title: "Peninsula Kitchen",
    image: "https://images.pexels.com/photos/1080721/pexels-photo-1080721.jpeg?auto=compress&cs=tinysrgb&w=1400",
    desc: "An attached island — the aesthetic of an island layout without needing a very large footprint. Doubles as a breakfast counter.",
    bestFor: "Semi-open plans, smaller rooms",
    bullets: ["Space-efficient island look", "Breakfast counter built-in", "Defines the kitchen zone"],
  },
];


export const MANIFESTO = [
  {
    no: "01",
    title: "We design for the way you actually live",
    body: "Not for photographs. Every layout starts with your routines, your family and the small rituals that make a house a home.",
  },
  {
    no: "02",
    title: "Technology removes the guesswork",
    body: "Photoreal 3D, precision manufacturing and live project tracking mean what you approve is exactly what you receive.",
  },
  {
    no: "03",
    title: "Craft is in the details you never see",
    body: "Marine-ply cores, calibrated hardware and finishes engineered to survive decades of everyday Indian living.",
  },
];
